import { z } from 'zod';
export const onboardingDraftVersion = 2;
export const paymentMethodValues = ['pix', 'credit', 'debit', 'cash', 'meal_voucher'];
export const fulfillmentMethodValues = ['pickup', 'own_delivery', 'delivery_app'];
export const weekdayValues = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'];
const shortText = z.string().max(120);
const mediumText = z.string().max(240);
const googlePlaceIdText = z.string().max(512);
const deliveryRadiusKm = z.number().positive().max(100).optional();
export const attributionSchema = z
    .object({
    referenceCode: shortText,
    platform: shortText,
    clickId: shortText,
    clickIdType: shortText,
})
    .partial()
    .strict();
export const storeDraftSchema = z
    .object({
    name: shortText,
    googlePlaceId: googlePlaceIdText,
    formattedAddress: shortText,
    latitude: shortText,
    longitude: shortText,
})
    .partial()
    .strict();
export const serviceScheduleSchema = z
    .object({
    day: shortText,
    isOpen: z.boolean(),
    opensAt: shortText,
    closesAt: shortText,
})
    .partial()
    .strict();
export const deliveryAreaDraftSchema = z
    .object({
    enabled: z.boolean(),
    radiusKm: deliveryRadiusKm,
    neighborhoods: z.array(shortText).max(80),
})
    .partial()
    .strict();
export const serviceDraftSchema = z
    .object({
    schedules: z.array(serviceScheduleSchema).max(7),
    paymentMethods: z.array(shortText).max(20),
    fulfillmentMethods: z.array(shortText).max(20),
    deliveryNotes: mediumText,
    deliveryArea: deliveryAreaDraftSchema,
})
    .partial()
    .strict();
export const onboardingDraftSchema = z
    .object({
    version: z.literal(onboardingDraftVersion),
    updatedAt: shortText,
    attribution: attributionSchema,
    store: storeDraftSchema,
    service: serviceDraftSchema,
})
    .partial()
    .strict();
export const putOnboardingRequestSchema = z
    .object({
    draft: onboardingDraftSchema,
})
    .strict();
export const weekdayLabelsPtBr = {
    mon: 'segunda',
    tue: 'terça',
    wed: 'quarta',
    thu: 'quinta',
    fri: 'sexta',
    sat: 'sábado',
    sun: 'domingo',
};
export const paymentMethodLabelsPtBr = {
    pix: 'pix',
    credit: 'cartão de crédito',
    debit: 'cartão de débito',
    cash: 'dinheiro',
    meal_voucher: 'vale-refeição',
};
export const fulfillmentMethodLabelsPtBr = {
    pickup: 'retirada',
    own_delivery: 'entrega própria',
    delivery_app: 'app de entrega',
};
export function parsePersistedOnboardingDraft(value) {
    const parsed = onboardingDraftSchema.safeParse(value);
    if (!parsed.success) {
        return null;
    }
    return parsed.data;
}
//# sourceMappingURL=index.js.map